import { render } from "./FormOption.vue?vue&type=template&id=61bc96b0&scoped=true&ts=true"
import script from "./FormOption.vue?vue&type=script&lang=ts"
export * from "./FormOption.vue?vue&type=script&lang=ts"

import "./FormOption.vue?vue&type=style&index=0&id=61bc96b0&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bc96b0"]])

export default __exports__